import { useState } from 'react'

interface Customer {
  id: number
  name: string
  phone?: string
  email?: string
}

interface Props {
  accountSlug: string
  onSaved: (customer: Customer) => void
  onSkip: () => void
}

export default function SaveCustomerModal({ accountSlug, onSaved, onSkip }: Props) {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [saving, setSaving] = useState(false)

  const handleSave = async () => {
    if (!name.trim()) return
    setSaving(true)

    try {
      const res = await fetch(`/${accountSlug}/pos/create_customer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
        body: JSON.stringify({
          name: name.trim(),
          phone: phone.trim() || null,
          email: email.trim() || null,
        }),
      })
      const data = await res.json()
      if (data.success) {
        onSaved(data.customer)
      } else {
        alert(data.error || 'Error al guardar')
      }
    } catch {
      alert('Error de conexión')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget && !saving) onSkip()
      }}
    >
      <div className="bg-white rounded-xl shadow-xl p-6 max-w-sm w-full">
        {/* Icono */}
        <div className="text-center mb-4">
          <div className="w-16 h-16 bg-[#FFC107] rounded-full flex items-center justify-center mx-auto mb-3">
            <span className="text-3xl">👤</span>
          </div>
          <h3 className="text-lg font-bold text-[#202020]">¿Guardar datos del cliente?</h3>
          <p className="text-sm text-gray-500 mt-1">
            Así podrás ver su historial de compras después.
          </p>
        </div>

        {/* Form */}
        <div className="space-y-3 mb-4">
          <input
            type="text"
            placeholder="Nombre del cliente *"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-3 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
            autoFocus
          />
          <input
            type="tel"
            placeholder="Teléfono"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="w-full px-3 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
          />
          <input
            type="email"
            placeholder="Email (opcional)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
          />
        </div>

        {/* Buttons */}
        <div className="flex gap-3">
          <button
            onClick={onSkip}
            disabled={saving}
            className="flex-1 py-3 bg-gray-100 text-gray-600 rounded-lg font-medium hover:bg-gray-200 transition-colors text-sm"
          >
            Omitir
          </button>
          <button
            onClick={handleSave}
            disabled={!name.trim() || saving}
            className="flex-1 py-3 bg-[#55ACEE] text-white rounded-lg font-medium hover:bg-[#4a9de0] transition-colors disabled:opacity-50 text-sm"
          >
            {saving ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  )
}
